export default __webpack_public_path__ + "static/media/PlanHindsightVariance.05e887de.png";